global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as newEnrollment from '../libs/tech.newEnrollment'
import * as redsysInsite from '../libs/tech.redsysInsite'
import * as formFunctions from '../libs/tech.formFunctions'
import * as stripeCheckOut from '../libs/tech.stripecheckout'
import * as ebanxsInsiteForm from '../libs/tech.ebanx'
import * as captchaV3 from '../libs/tech.captchaV3'
import * as paywayForm from '../libs/tech.paywayForm'

export { core, lazyLoad, newEnrollment, redsysInsite, formFunctions, stripeCheckOut, ebanxsInsiteForm, captchaV3, paywayForm }